<template>
  <div class="relative" :cn="componentName">
    <label v-if="hasLabelSlot" v-bind:class="cssLabel">
      <slot name="label"></slot>
    </label>

    <div class="relative rounded-md">
      <div
        class="
          flex
          border-2
          items-center
          text-base
          border-gray-200
          dark:border-transparent
          dark:hover:border-slate-500
          dark:focus-visible:border-slate-500
          focus-visible:border-accent-color
          rounded-md
          py-1
          px-3
        "
        :class="{'bg-neutral-100 dark:bg-gray-900 cursor-not-allowed' : disabled, 'dark:bg-gray-700 bg-white' : !disabled }"
      >
              <button
          class="outline-none
            focus:outline-none
            transition-all
            text-red-500
            pr-2"
          v-show="canBeInvalid && !isValidSelection"
          :title="options.not_valid ?? 'Invalid selection'"
          @click.prevent="$emit('dropdown:clear', $event)"
        >
          <i class="fas fa-exclamation-triangle"></i>
        </button>
        <input
        :ref="setref"
        :cy="'input_' + setref"
          class="
            appearance-none
            outline-none
            text-gray-800
            w-full
            bg-inherit
            text-inherit
          "
          checked=""
          @input="$emit('update:search', $event.target.value)"
          :autocomplete="getUniq()"
          :class="inputclass"
          :disabled="disabled"
          :value="search"
          @focus="focusIn()"
          @blur="focusOut()"
          :placeholder="options.placeholder"
          @keydown.enter="pressedEnter()"
          @keydown.tab="pressedTab()"
        />

        <button
        v-if="!disabled && clear_button"
        :tabindex="tabIndexButton"
          class="
            cursor-pointer
            outline-none
            focus:outline-none
            transition-all
            text-gray-300
            hover:text-gray-600
          "
          v-show="selected != 0"
          :title="options.title_clear"
          @click.prevent="$emit('dropdown:clear', $event)"
        >
          <i class="fas fa-times"></i>
        </button>
      </div>

      <!-- <input type="checkbox" name="show_more" id="show_more" class="hidden peer" checked=""> -->
      <transition ref="scroller" class="overflow-y-auto max-h-[400px]" name="fade">
        <div
          v-show="openDrop"
          v-bind:class="[openDrop ? 'block' : 'hidden']"
          ref="list"
          class="
            absolute
            rounded
            shadow
            bg-white
            dark:bg-gray-700
            text-stone-900
            dark:text-slate-100
            peer-checked:flex
            flex-col
            w-full
            mt-1
            border-2 border-gray-200
            dark:border-slate-600
            z-20
          "
          v-on:scroll.passive='handleScroll($event)'
        >
          <div
          v-if="options.adder != undefined || options.edit != undefined"
          class="cursor-pointer flex flex-row "
          >
          <a
          v-if="options.adder != undefined && !selected"
             @click.prevent="$emit('dropdown:new', $event, search)"
              class="
                block
                p-2
                border-transparent
                hover:bg-gray-100
                dark:hover:bg-slate-800 dark:hover:border-slate-500
                font-bold
                flex flex-auto
              "
            >
              <i class="fas fa-plus mr-2"></i> {{ options.adder }}
            </a>
            <a
             v-if="options.edit != undefined && selected"
            @click.prevent="$emit('dropdown:edit', $event, search)"
              class="
                block
                p-2
                border-transparent
                hover:bg-gray-100
                dark:hover:bg-slate-800 dark:hover:border-slate-500
                font-bold
                flex flex-auto
              "
            >
              <i class="fas fa-pencil mr-2"></i> {{ options.edit }}
            </a>
          </div>

          <transition-group name="list" :duration="{ enter: 200, leave: 200 }">
            <div
              class="
                cursor-pointer
                border-t border-t-gray-200
                dark:border-t-slate-600
              "
              :class="{
                'bg-gray-100 dark:bg-slate-800': value[id] == selected,
                'bg-gray-300 dark:bg-slate-500': (index == 0 && selectElementOnUnfocus == true),
                'cursor-no-drop	opacity-50' : value.disabled === true
              }"
              v-for="(value, index) in filterdValues"
              :key="value[id]"
              :data-index="index"
              :disabled="value.disabled"
              @click.prevent="setValue(value)"
                :cy="'option_' + setref + '_' + index"
                :cn="componentName + '_' + index"
            >
              <a
                class="
                  block
                  p-2
                  border-transparent
                  hover:bg-gray-100
                  dark:hover:bg-slate-800 dark:hover:border-slate-500
                "
              >
                <span v-for="(key, index) in keys" :key="(this.noId == undefined) ? key : index">
                  <div class="w-full" v-if="index == 0">
                    {{ lodash.get(value, key) }}
                  </div>
                  <div class="w-full subinfo" v-else>
                    {{ lodash.get(value, key) }}
                  </div>
                </span>
              </a>
            </div>

            <div
              key="loading"
              v-if="isLoading"
              class="
                border-t border-t-gray-200
                dark:border-t-slate-600
                text-center text-sm
              "
            >
              <a class="block p-2 border-transparent"
                ><simple-loading-icon></simple-loading-icon
              ></a>
            </div>
          </transition-group>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    canBeInvalid: {
        type: Boolean,
        default: true,
    },
    canBeEmpty: {
        type: Boolean,
        default: true,
    },
    search: {},
    options: {},
    selected: {},
    values: {
      default : []
    },
    keys: { type: Array, required : true},
    selectkeys: {},
    noId: {},
    isLoading: {},
    inputclass: {},
    init: {},
    predefinedStyle: {},
    disabled: { type: Boolean, default: false },
    setHeight: {
      type: Number,
      default: 400,
    },
    uniq: {
      type: String,
      default : "0",
    },
    setref: {
        type: String,
    },
    clear_button:{
      type : Boolean,
      default: true,
    },
    selectElementOnUnfocus: {
        type: Boolean,
        default : false,
    },
    watchForChange: {
        type: Boolean,
        default: true,
    },
    tabIndexButton: {
        default : "-1",
        type : String,
    }
  },
  data() {
    return {
      openDrop: false,
      displayLoadingIcon: false,
      predefinedStyles: {
        default: {
          label:
            "text-base text-stone-900 dark:text-slate-100 font-bold block mb-1",
        },
      },
      maxAdditionalLoad : 10,
      debounce : {
        isLoading : null,
      },
    };
  },
  watch: {
    filterdValues(newVal, oldVal){
      if(this.isLoading == false){
        clearTimeout(this.debounce.isLoading);
        this.debounce.isLoading = setTimeout(function(){
          this.maxAdditionalLoad--;
          if (this.$refs && this.$refs.list && this.$refs.list.getBoundingClientRect() !== undefined) {
            if((this.$refs.list.getBoundingClientRect().height > 0 && this.$refs.list.getBoundingClientRect().height <= this.setHeight) || this.$refs.list.scrollHeight >= this.setHeight){
                this.$emit("menu:loadmore");
            }
          }
        } , 500)
      }
    },
    "selected" : {
      immediate: true,
      handler(newVal, oldVal){
        if(newVal != oldVal && this.watchForChange){
          var value = this.filterdValues.find(item => item[this.id] == newVal);
          if(value){
            this.setValue(value);
          }
        }
      }
    },
    search(newVal, oldVal) {
        if(oldVal && newVal && newVal.trim() == ""){
            this.$emit('dropdown:clear', {})
        }
    }
  },
  mounted() {
    if (this.init != undefined) {
      this.setValue(this.values.find(item => item[this.id] == this.init))
    }
    this.emitter.on("dropdownsearch:set" + this.uniq, (event) => {
      this.setValue(this.values.find(item => item[this.id] == event))
    });
      if(this.setref != undefined){
            this.emitter.on("dropdownsearchmenu:" + this.setref + ":focus", (event) => {
                this.$refs[this.setref].focus();
            })
        }
  },
  computed: {
    selectionValue(){
        if(this.selectedElement){
            let search = "";
            for (let i = 0; i < this.keysSelect.length; i++) {
                search = search + _.get(this.selectedElement, this.keysSelect[i]);
            }
            return search;
        }
        return "";
    },
    isSearchEmpty(){
        return (!this.search || this.search.trim() === "" );
    },
    isSearchMatchingSelection(){
        return (this.search && this.search.trim() === this.selectionValue.trim());
    },
    isSelectedFound(){
        return this.values.some(item => item[this.id] === this.selected);
    },
    isValidSelection(){
        if (this.canBeEmpty && this.isSearchEmpty) {
            return true;
        }
        if (this.isSearchMatchingSelection && !this.isSearchEmpty) {
            return true;
        }
        if (this.isSelectedFound && this.isSearchMatchingSelection) {
            return true;
        }
        if (!this.canBeEmpty && this.isSearchEmpty) {
            return false;
        }
        return false;
  },
  selectedElement(){
    let index = this.values.findIndex(item => item[this.id] == this.selected);
    if(index >= 0){
       return this.values[index];
    }
    return null;
  },
    componentName(){
      return "DropdownSearchMenu";
    },
    lodash() {
      return _;
    },
    id() {
      if (this.noId == undefined) {
        return "id";
      }
      return this.noId;
    },
    filterdValues() {
      var list = [];
      if (
        this.values == undefined ||
        this.values.length == undefined ||
        this.values.length <= 0
      ) {
        return [];
      }
        for (let i = 0; i < this.keys.length; i++) {
          list.push(
            ...this.values.filter((item) => {
              try {
                return (
                  _.get(item, this.keys[i]) != "null" &&
                _.get(item, this.keys[i])
                  .toLowerCase()
                  .indexOf(this.search.trim().toLowerCase()) > -1
              );
            } catch (error) {
              return this.values;
            }
          })
        );
      }
      return this.distinct(list, this.id);
    },
    keysSelect() {
      if (this.selectkeys != undefined) {
        return this.selectkeys;
      }
      return this.keys;
    },
    cssLabel: function () {
      if (
        this.predefinedStyle !== undefined &&
        this.predefinedStyles[this.predefinedStyle] !== undefined
      ) {
        return this.predefinedStyles[this.predefinedStyle]["label"];
      }
      return this.predefinedStyles["default"]["label"];
    },
    hasLabelSlot() {
      return !!this.$slots.label;
    },
  },
  methods: {
    handleScroll(event) {
      if (this.isLoading == false) {
        if (
          this.$refs.list.getBoundingClientRect().height - 50 <=
          event.target.getBoundingClientRect().height + event.target.scrollTop
        ) {
          this.$emit("menu:loadmore");
        }
      }
    },
    distinct(myArray, prop) {
      return myArray.filter((obj, pos, arr) => {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    focusOut: function () {
      setTimeout(() =>  {
        if(!this.selected || this.selected == 0 || this.selected == ""){
            if(this.selectElementOnUnfocus == true && this.filterdValues.length > 0){
                this.setValue(this.filterdValues[0]);
            }
        }
          this.openDrop = false;
        } ,
        150
      );
    },
    focusIn() {
      this.openDrop = true;
      this.$emit("clear:search", "");
    },
    setValue: function (value) {
      if(!value || value.disabled === true){
        return ;
      }
      var search = "";
      for (let i = 0; i < this.keysSelect.length; i++) {
        search = search + _.get(value, this.keysSelect[i]);
      }
      this.$emit("dropdown:select", value, search);
      this.openDrop = false;
    },
    pressedEnter(){
        if(!this.selected || this.selected == 0 || this.selected == ""){
            if(this.selectElementOnUnfocus == true){
                this.setValue(this.filterdValues[0]);
            }
            this.openDrop = false;
            this.$emit('dropdown:moveon', _.get(this, 'filterdValues', []));
            this.$emit('dropdown:enter', _.get(this, 'filterdValues', []));
        }
    },
    pressedTab(){
        if(!this.selected || this.selected == 0 || this.selected == ""){
            if(this.selectElementOnUnfocus == true && this.filterdValues != undefined && this.filterdValues[0] != undefined){
                this.setValue(this.filterdValues[0]);
            }
            this.openDrop = false;
            this.$emit('dropdown:moveon', _.get(this, 'filterdValues', []));
            this.$emit('dropdown:tab', _.get(this, 'filterdValues', []))
        }
    }
  },
};
</script>
<style scoped>
.subinfo {
  font-size: 0.75em;
  opacity: 75%;
}
.is-fullwidth {
  width: 100% !important;
}
.dropdown-item {
  display: inline-block;
  margin-right: 10px;
}
.on-input {
  border-left: none;
}
.button:hover {
  transform: scale(1.1);
}
.list-enter-active,
.list-leave-active {
  transition: all 1s;
}
.list-enter,
.list-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-active {
  transition: opacity 0.3s ease reverse;
}

.fade-leave-to {
  opacity: 0;
}
.fade-enter-from {
  opacity: 100;
}

body {
  font-size: small;
}

.searchdropdown {
  border: none !important;
}
</style>
